import './ImageFitter.css';
import domtoimage from 'dom-to-image';
import { saveAs } from 'file-saver';
import { useState, useEffect } from 'react';
import PaletteIcon from '@material-ui/icons/Palette';

function ImageFitter({ fileInfo, ratio }) {
    let [ar, setAr] = useState("w-150")
    let [backgroundImage, setBackgroundImage] = useState("")
    let [iconColor, setIconColor] = useState("rgb(139 92 246)");
    useEffect(() => {
        setAr(getWidth(ratio));
    });

    function savehtml(itemId, imageName) {
        let scale = 4
        let node = document.getElementById(itemId, imageName)
        
        // domtoimage.toBlob(node, {
        //     width: node.clientWidth * scale,
        //     height: node.clientHeight * scale,
        //     style: {
        //         transform: 'scale(' + scale + ')',
        //         transformOrigin: 'top left'
        //     }
        // }).then(function (blob) {
        //     window.saveAs(blob, 'fitit_' + fileInfo['name']);
        // });

        domtoimage.toBlob(node, {
            width: node.clientWidth * scale,
            height: node.clientHeight * scale,
            style: {
                transform: 'scale(' + scale + ')',
                transformOrigin: 'top left'
            }
          }).then(dataUrl => {
          domtoimage
            .toBlob(node, {
                width: node.clientWidth * scale,
                height: node.clientHeight * scale,
                style: {
                    transform: 'scale(' + scale + ')',
                    transformOrigin: 'top left'
                }
            })
            .then(blob => {
                window.saveAs(blob, 'fitit_' + fileInfo['name']);
            });
          });

    }

    function getWidth(ratio) {
        if (ratio === '16x9') {
            return 'w-150'
        }
        if (ratio === '1x1') {
            return 'w-96'
        }
        if (ratio === '4x3') {
            return 'w-128'
        }
        if (ratio === '9x16') {
            return 'w-72'
        }
    }

    function selectEffectType(effectType, color) {
        if (color) {
            backgroundImage = <div className="object-cover h-96 z-10 transform scale-105" style={{ backgroundColor: color }} ></div>
        } else {
            backgroundImage = <img className="object-cover h-96 w-full filter blur-lg z-10 transform scale-105" src={fileInfo['path']} alt="Oops!"></img>;
            color = "rgb(139 92 246)";
        }
        setBackgroundImage(backgroundImage)
        setIconColor(color);
    }

    return (
        <div className="flex flex-col items-center justify-center overflow-hidden">
            <div className="p-5 transform scale-50 md:transform md:scale-100">
                <div className={`relative h-96 ${ar}`} id={fileInfo['path']} >
                    <img className="object-contain h-96  w-full z-20 absolute" src={fileInfo['path']} alt="Oops!"></img>
                    <div className="overflow-hidden">
                        {backgroundImage ? backgroundImage : <img className="object-cover h-96 w-full filter blur-lg z-10 transform scale-105" src={fileInfo['path']} alt="Oops!"></img>}
                    </div>
                </div>
                <div className="flex justify-center items-center space-x-10 mt-8 mb-8 ml-10">
                    <button className="md:transform md:scale-125 transform scale-175 border-purple-500 p-0.5 text-purple-500 hover:bg-purple-500 hover:text-white rounded-md" onClick={() => selectEffectType("blur", "")}>Blur</button>
                    <label>
                        <div className="transform scale-175 md:transform md:scale-125" >
                            <PaletteIcon color="secondary" style={{ color: iconColor }} ></PaletteIcon>
                            <input type="color" className="opacity-0" value="#ffe082" onChange={(event) => { selectEffectType("color", event.target.value) }} />
                        </div>
                    </label>
                </div>
                <div className="flex justify-center">
                    <button className="border-2 md:transform md:scale-100 transform scale-175 border-blue-500 p-1 text-blue-500 hover:bg-blue-500 hover:text-white rounded-md mb-4" onClick={() => savehtml(fileInfo['path'], fileInfo['name'])}>Download</button>
                </div>
            </div>
        </div>

    );
}
export default ImageFitter;